import { render, staticRenderFns } from "./AddEditReturnModal.vue?vue&type=template&id=2ab4d49e&scoped=true"
import script from "./AddEditReturnModal.vue?vue&type=script&lang=js"
export * from "./AddEditReturnModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditReturnModal.vue?vue&type=style&index=0&id=2ab4d49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab4d49e",
  null
  
)

export default component.exports